import { observable, action, makeAutoObservable  } from 'mobx'
import { getShapesList } from '../components/helper';
import { fetchGifs, fetchStickers } from '../services/ElementService';
import { Element } from './componentStore'

class ElementStore {

  constructor(errorStore) {
    makeAutoObservable(this);
    this.errorStore = errorStore
  }
  
  //change
  stickers = []
  elements = []
  gifs = {
    f_row: [],
    s_row: []
  }
  fullGifs = []
  stickers = []
  stickersLoading = false
  gifsLoading = false
  moreStickers = true
  moreGifs = true
  gifPage = 0
  fullGifPage = 0
  stickersPage = 0
  fullStickersPage = 0
  searchQuery = ''
  loading = false

  mapGifs(gifs){
    //const ids = [...this.gifs.f_row.map(g => g.id), ...this.gifs.s_row.map(g => g.id)]
    gifs.forEach((g, i) => {
      //if(!ids.includes(g.id)){
        if(i % 2 === 0){
          this.gifs.s_row.push(g)
        }else{
          this.gifs.f_row.push(g)
        }
      //}
    })
  }

  setSearchTerm(t){
    this.searchQuery = t
  }

  async getFullGifs(){
    if(!this.moreGifs){
      return
    }
    this.gifsLoading = true
    const data = await fetchGifs(this.searchQuery, this.fullGifPage, 30)
    this.fullGifs.push(...data.gifs)
    this.moreGifs = data.more
    setTimeout(() => {
      this.gifsLoading = false
    }, 1000)
  }

  async getFullStickers(){
    if(!this.moreStickers){
      return
    }
    this.stickersLoading = true
    const data = await fetchStickers(this.searchQuery, this.fullStickersPage, 30)
    if(this.fullStickersPage === 0){
      this.stickers = data.stickers
    }else{
      this.stickers.push(...data.stickers)
    }
    this.moreStickers = data.more
    setTimeout(() => {
      this.stickersLoading = false
    }, 1000)
  }

  increaseFullGifPage(){
    this.fullGifPage += 1
  }

  increaseFullStickersPage(){
    this.fullStickersPage += 1
  }

  initFullPages(){
    this.fullStickersPage = 0
    this.fullGifPage = 0
  }

  async getGifs(isFull = false){
    if(!this.moreGifs){
      return
    }
    this.gifsLoading = true
    const data = await fetchGifs(this.searchQuery, this.gifPage, isFull ? 50 : null)
    this.mapGifs(data.gifs)
    if(!data.more){
      this.moreGifs = false
    }else{
      this.moreGifs = true
    }
    setTimeout(() => {
      this.gifsLoading = false
    }, 1000)
  }

  async getStickers(){
    if(!this.moreStickers){
      return
    }
    this.stickersLoading = true
    const data = await fetchStickers(this.searchQuery, this.stickersPage)
    this.stickers.push(...data.stickers)
    if(!data.more){
      this.moreGifs = false
    }else{
      this.moreGifs = true
    }
    setTimeout(() => {
      this.stickersLoading = false
    }, 1000)
  }

  async searchRegular(stickers = false){
    if(stickers){
      const stickerData = await fetchStickers(this.searchQuery, this.stickersPage)
      this.stickers = stickerData.stickers
      if(stickerData.more){
        this.moreStickers = true
      }else{
        this.moreStickers = false
      }
    }
    if(!stickers){
      const data = await fetchGifs(this.searchQuery, this.gifPage)
      this.gifs = {
        f_row: [],
        s_row: []
      }
      this.mapGifs(data.gifs)
      if(data.more){
        this.moreGifs = true
      }else{
        this.moreGifs = false
      }
    }
  }

  setSingleGifLoading(gifId, row){
    if(!row){
      const idx = this.fullGifs.findIndex(({ id }) => id === gifId)
      this.fullGifs[idx].loading = false
      return
    }
    const idx = this.gifs[row].findIndex(({ id }) => id === gifId)
    this.gifs[row][idx].loading = false
    return
  }

  setStickerLoading(stickerId){
    const idx = this.stickers.findIndex(({ id }) => id === stickerId)
    this.stickers[idx].loading = false
  }

  async searchByTerm(t, fullGifsView = false, fullStickersView = false){
    this.searchQuery = t
    if(fullGifsView){
      if(!this.moreGifs){
        return
      }
      this.fullGifPage = 0
      this.gifsLoading = true
      const data = await fetchGifs(this.searchQuery, this.fullGifPage, 15)
      this.fullGifs = [...data.gifs]
      this.moreGifs = data.more
      this.gifs = {
        f_row: [],
        s_row: []
      }
      this.mapGifs(data.gifs)
      this.searchRegular(true)
    }
    if(fullStickersView){
      if(!this.moreStickers){
        return
      }
      this.fullStickersPage = 0
      this.stickersLoading = true
      const data = await fetchStickers(this.searchQuery, this.fullStickersPage, 15)
      this.stickers = data.stickers
      this.moreStickers = data.more
      this.searchRegular()
    }
    if(fullStickersView || fullGifsView){
      setTimeout(() => {
        this.gifsLoading = false
        this.stickersLoading = false
      }, 500)
      return
    }
    this.gifsLoading = true
    this.stickersLoading = true
    this.gifPage = 0
    this.stickersPage = 0
    this.moreGifs = true
    this.moreStickers = true
    this.searchRegular(false)
    this.searchRegular(true)
    setTimeout(() => {
      this.gifsLoading = false
      this.stickersLoading = false
    }, 500)
  }

  increaseGifPage(){
    this.gifPage += 1
  }

  increaseStickersPage(){
    this.stickersPage += 1
  }

  async findShapes(){

    let objectsPrefix = '/objects';
    if(process.env.REACT_APP_NODE_ENV !== 'development') {
      objectsPrefix = '/design-editor/objects';
    }

    this.loading = true
    const list = getShapesList()
    list.forEach(name => {
      const element = new Element(
        name, 
        `${objectsPrefix}/${name}`,
        100,
        100,
        100,
        100,
        100,
        100,
        0,
        0,
        0,
        0,
        1,
        1,
        '#656565',
        0,
        null,
        null,
        name,
        {
          x: 1,
          y: 1,
          z: 1
        },
        'left',
        'top',
        false
      )
      this.elements.push(element)
    })
    this.loading = false
  }

}

export default ElementStore